import _regeneratorRuntime from 'babel-runtime/regenerator';
import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import DragTree from '@com/components/drag-tree/tree.vue';
import { mapState } from 'vuex';
import NodeItem from './node-item.vue';
import { getBaseResourceType } from '@/store/creative/common/resource';
import { isGroup, unGroup, findById, newTreeItem, switchParent, isLimitPlayItem, isPresetCategory, isHiddenCategory } from './tree.js';
import _ from 'lodash';
import { gameConfigCategoryResourceType, isPresetConfigParentCategory, isPresetOptionCategory } from '@/store/creative/common/category';

export default {
  props: ['list', 'sortType', 'activeNodes', 'categoryData', 'treeName', 'currentDropTree', 'dragStartTree', 'handleNodeExpand', 'defaultExpandedMap'],
  components: {
    // nestedDraggable,
    DragTree: DragTree,
    NodeItem: NodeItem
  },
  data: function data() {
    return {
      defaultProps: {
        label: 'name',
        children: 'sub_category'
      }
    };
  },

  computed: _extends({
    treeProps: function treeProps() {
      return {
        draggable: true,
        highlightCurrent: true,
        expandOnClickNode: false,
        nodeKey: 'id'
      };
    }
  }, mapState({
    templateConfig: function templateConfig(state) {
      return state.creative.template.templateConfig;
    },
    isCommonTemplatePage: function isCommonTemplatePage(state) {
      return state.creative.template.isCommonTemplatePage;
    }
  }), {
    limitLevel: function limitLevel() {
      return this.treeName === 'categoryTree' ? 2 : 1;
    }
  }),
  methods: {
    isLimitPlayItem: isLimitPlayItem,
    isPresetCategory: isPresetCategory,
    handleDragTreeEnd: function handleDragTreeEnd(event) {
      var _this = this;

      if (this.treeName === 'playTree' && this.activeNodes.some(function (item) {
        return item.resource_type !== gameConfigCategoryResourceType;
      })) {
        this.$message.error('移动内容非玩法配置');
        return;
      }
      var pid = 1;
      if (this.treeName === 'expandTree') {
        pid = 4;
      }
      if (this.treeName === 'playTree') {
        pid = 3;
      }
      var targetParent = findById(this.categoryData, pid);
      if (targetParent.sub_category.length) return;
      switchParent({
        nodes: this.activeNodes,
        index: 0,
        target: targetParent,
        tree: this.categoryData
      });
      setTimeout(function () {
        _this.$emit('updateList', _this.categoryData);
      }, 0);
      // this.$emit('drag-tree-end', event, this.treeName)
    },
    handleDragTreeEnter: function handleDragTreeEnter(event) {
      this.$emit('dragTreeEnter', this.treeName);
    },
    getRefCategory: function getRefCategory(category) {
      var baseResourceType = getBaseResourceType(category.resource_type);
      return _.get(this.templateConfig, ['category_ref', baseResourceType, category.prefix], []);
    },
    handleDrop: function handleDrop(draggingNode, dropNode, dropType) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var dropNodeAction;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this2.currentDropTree !== _this2.treeName)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return', false);

              case 2:
                dropNodeAction = function dropNodeAction(node) {
                  var sourceDrop = findById(_this2.categoryData, dropNode.data.id);
                  // 元素到元素
                  var section1 = !isGroup(node) && !isGroup(sourceDrop) && dropType === 'inner' && dropNode.level > (_this2.isSceneNode(dropNode.data) ? 2 : _this2.limitLevel - 1);
                  // 组到元素
                  var section2 = isGroup(node) && !isGroup(sourceDrop) && dropType === 'inner' && dropNode.level > (_this2.isSceneNode(dropNode.data) ? 2 : _this2.limitLevel - 1);
                  // 组到组
                  var section3 = isGroup(node) && isGroup(sourceDrop) && dropType === 'inner' && dropNode.level > (_this2.isSceneNode(dropNode.data) ? 2 : _this2.limitLevel - 1);
                  // 元素到组
                  var section4 = !isGroup(node) && isGroup(sourceDrop) && dropType === 'inner' && dropNode.level > (_this2.isSceneNode(dropNode.data) ? 2 : _this2.limitLevel - 1);
                  if (section1 || section2) {
                    var targetParent = findById(_this2.categoryData, dropNode.data.pid);
                    var groupIndex = targetParent.sub_category.findIndex(function (item) {
                      return item.id === dropNode.data.id;
                    });
                    var newGroup = newTreeItem(targetParent.id);
                    // 默认展开
                    _this2.handleNodeExpand(newGroup);
                    var dragId = isGroup(node) ? node.sub_category.map(function (item) {
                      return item.id;
                    }) : [node.id];
                    targetParent.sub_category.splice(groupIndex, 0, newGroup);
                    switchParent({
                      nodes: findById(_this2.categoryData, [].concat(_toConsumableArray(dragId), [dropNode.data.id])),
                      index: 0,
                      target: newGroup,
                      tree: _this2.categoryData
                    });
                    if (isGroup(node)) {
                      var parent = findById(_this2.categoryData, node.pid);
                      parent.sub_category.splice(parent.sub_category.findIndex(function (item) {
                        return item.id === node.id;
                      }), 1);
                    }
                  } else if (section3 || section4) {
                    // 组到组 || 元素到组
                    var target = findById(_this2.categoryData, dropNode.data.id);
                    var _dragId = isGroup(node) ? node.sub_category.map(function (item) {
                      return item.id;
                    }) : [node.id];
                    switchParent({
                      nodes: findById(_this2.categoryData, _dragId),
                      index: target.sub_category && target.sub_category.length ? target.sub_category.length - 1 : 0,
                      target: target,
                      tree: _this2.categoryData
                    });
                    if (isGroup(node)) {
                      var _parent = findById(_this2.categoryData, node.pid);
                      _parent.sub_category.splice(_parent.sub_category.findIndex(function (item) {
                        return item.id === node.id;
                      }), 1);
                    }
                  } else if (dropType === 'inner') {
                    var _targetParent = findById(_this2.categoryData, dropNode.data.id);
                    switchParent({
                      nodes: findById(_this2.categoryData, node.id),
                      index: _targetParent.sub_category && _targetParent.sub_category.length ? _targetParent.sub_category.length - 1 : 0,
                      target: _targetParent,
                      tree: _this2.categoryData
                    });
                  } else {
                    var _targetParent2 = findById(_this2.categoryData, dropNode.data.pid);
                    var index = _targetParent2.sub_category.findIndex(function (item) {
                      return item.id === dropNode.data.id;
                    });
                    var getIndex = function getIndex() {
                      if (isLimitPlayItem(dropNode.data)) {
                        return _this2.list.sub_category.filter(function (item) {
                          return isLimitPlayItem(item);
                        }).length;
                      }
                      return dropType === 'after' ? index + 1 : index;
                    };
                    switchParent({
                      nodes: findById(_this2.categoryData, node.id),
                      index: getIndex(),
                      target: _targetParent2,
                      tree: _this2.categoryData
                    });
                  }
                };

                _this2.activeNodes.forEach(function (node) {
                  dropNodeAction(node);
                });
                _this2.$emit('updateList', _this2.categoryData);
                //

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    filterNodes: function filterNodes(node) {
      /**
       * 限制拖拽的资源类型
       * 当前限制的分类有，json、动画分类、镜头分类、材质分类
       */
      return !isHiddenCategory(node, this.isCommonTemplatePage) && !isPresetConfigParentCategory(node);
    },
    handleDragStart: function handleDragStart(node, event) {
      // 拖拽图片添加
      var elem = document.createElement('div');
      elem.id = 'drag-ghost';
      // const num = this.activeNodes.length || 1
      elem.innerHTML = '';
      document.body.appendChild(elem);
      event.dataTransfer.setDragImage(elem, 0, 0);
      if (this.activeNodes.every(function (item) {
        return item.id !== node.data.id;
      })) {
        this.$emit('updateNode', node);
      }
      this.$emit('dragStart', node, event, this.treeName);
    },
    handleDragEnd: function handleDragEnd(draggingNode, endNode, position, event) {
      // 拖拽图片移除
      var ghost = document.getElementById('drag-ghost');
      if (ghost && ghost.parentNode) {
        ghost.parentNode.removeChild(ghost);
      }
      if (this.treeName === this.dragStartTree) {
        this.$emit('dragEnd', draggingNode, endNode, position, event, this.treeName);
      }
    },
    handleDragOver: function handleDragOver(draggingNode, dropNode, event) {
      this.$emit('dragOver', draggingNode, dropNode, event, this.treeName);
    },

    // 树节点右键菜单
    handleTreeCopyNode: function handleTreeCopyNode(event, data, node) {
      var _this3 = this;

      var menu = [{
        name: '解除组',
        callback: function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    unGroup({
                      node: node.data,
                      tree: _this3.categoryData
                    });
                    _this3.$emit('updateList', _this3.categoryData);

                  case 2:
                  case 'end':
                    return _context2.stop();
                }
              }
            }, _callee2, _this3);
          }));

          return function callback() {
            return _ref.apply(this, arguments);
          };
        }()
      }];
      this.$emit('menu', {
        menu: isGroup(data) && !isPresetOptionCategory(data) && !this.isRefCategory(data) ? menu : [],
        event: event,
        node: node
      });
    },
    handleCurrentChange: function handleCurrentChange(data, node) {
      // 更新activeedNode
      this.$emit('updateNode', node);
    },
    isRefCategory: function isRefCategory(node) {
      return this.getRefCategory(node).length > 1;
    },
    allowDrop: function allowDrop(draggingNode, dropNode, type) {
      var _this4 = this;

      if (this.currentDropTree !== this.treeName) {
        // 当前树非拖动目标树，不允许drop
        return false;
      }
      var nodeAllowDrop = function nodeAllowDrop(node) {
        if (_this4.treeName === 'playTree' && node.resource_type !== gameConfigCategoryResourceType && (node.resource_type !== 'group' || node.resource_type === 'group' && node.sub_category && node.sub_category.some(function (item) {
          return item.resource_type !== gameConfigCategoryResourceType;
        }))) {
          // 玩法树只允许放置玩法内容
          return false;
        }
        if (isLimitPlayItem(dropNode.data) && type === 'inner') {
          // 通用玩法不支持排序
          return false;
        }
        // 预设拖拽限制：
        // 1.任意节点不允许拖拽进预设
        // 2.预设节点只能在一级分类排序拖拽
        // 3.禁止拖拽进入组内
        // if (
        //   (isPresetCategory(dropNode.data) && type === 'inner') ||
        //   (isPresetCategory(draggingNode.data) &&
        //     dropNode.level !== 1 &&
        //     type === 'inner') ||
        //   (isPresetCategory(draggingNode.data) && isGroup(dropNode.parent.data))
        // ) {
        //   // 预设无法打组
        //   return false
        // }
        if (type === 'inner' && _this4.activeNodes.length > 1 && !dropNode.data.sub_category) {
          // 多选拖拽，禁止对普通元素做inner操作
          return false;
        }
        if (type === 'inner' && dropNode.level === 1 && dropNode.data.id === 9) {
          // 元素树，无法拖拽新增场景节点
          return false;
        } else if (type !== 'inner' && dropNode.level === 2 && dropNode.parent.data.id === 9) {
          // 元素树，无法拖拽新增场景节点
          return false;
        } else if (dropNode.level === 1 && type !== 'inner' && _this4.treeName === 'categoryTree') {
          // 元素树不允许拖拽生成一级分类
          return false;
        } else if (isGroup(node) && _this4.isSceneNode(dropNode.data) && (type === 'inner' || dropNode.level > 3)) {
          // 场景节点下拖拽组节点，目标位置大于二级不允许inner drop，目标大于三级不允许任何drop
          return false;
        } else if (isGroup(node) && !_this4.isSceneNode(dropNode.data) && (type === 'inner' || dropNode.level > _this4.limitLevel)) {
          // 非场景节点下拖拽组节点，目标位置大于一级不允许drop，目标等于一级不允许inner drop
          return false;
        } else if (_this4.isSceneNode(dropNode.data) && dropNode.level > 3 && type === 'inner') {
          // 场景节点下大于三级禁止inner
          return false;
        } else if (!_this4.isSceneNode(dropNode.data) && dropNode.level > _this4.limitLevel && type === 'inner') {
          // 非场景节点大于二级禁止inner
          return false;
        } else if (_this4.isRefCategory(dropNode.parent.data) || isGroup(dropNode.data) && _this4.isRefCategory(dropNode.data) && type === 'inner') {
          // 目标节点为组节点且目标节点为关联元素且拖拽类型为inner
          return false;
        }
        return true;
      };
      if (this.activeNodes.length > 1) {
        return this.activeNodes.every(function (node) {
          return nodeAllowDrop(node) === true;
        });
      }
      return nodeAllowDrop(draggingNode.data);
    },


    // 检查元素是否在场景节点中
    isSceneNode: function isSceneNode(node) {
      var category = this.categoryData.find(function (item) {
        return item.id === 1;
      });
      var scene = category.sub_category.find(function (item) {
        return item.id === 9;
      });
      if (!scene) {
        return false;
      }
      var srcNode = findById(scene.sub_category, node.id);
      return !!srcNode;
    },
    nodeAllowDrag: function nodeAllowDrag(node) {
      var parent = findById(this.categoryData, node.pid);
      if (!parent) {
        return false;
      }
      if (parent.id === 9) {
        // 场景节点禁止拖拽
        return false;
      }
      if (isLimitPlayItem(node)) {
        // 通用玩法禁止拖拽
        return false;
      }
      if (parent.id === 1) {
        // 元素树，根节点无法拖拽
        return false;
      }
      if (parent.resource_type === gameConfigCategoryResourceType) {
        // 父节点为玩法的节点，禁止拖拽
        return false;
      }
      // 关联组的子节点不允许拖拽
      if (isGroup(parent) && this.isRefCategory(parent)) {
        return false;
      }
      return true;
    },
    allowDrag: function allowDrag(draggingNode) {
      var _this5 = this;

      // if (draggingNode.level <= 1 && this.dragStartTree === 'categoryTree') {
      //   return false
      // }
      if (this.activeNodes.length > 1) {
        return this.activeNodes.every(function (node) {
          return _this5.nodeAllowDrag(node) === true;
        });
      }
      return this.nodeAllowDrag(draggingNode.data);
    }
  }
};